module.exports = __webpack_public_path__ + "img/3.118b5adc.jpg";